import React from "react";
import { Carousel } from "antd";
import { Link } from "react-router-dom";
import "./index.scss"
import index1 from "../assets/home-page/index1.png"
import index2 from "../assets/home-page/index2.png"
import index3 from "../assets/home-page/index3.png"
import split from "../assets/home-page/split.png"
import circleTxt from "../assets/home-page/circleTxt.png"
import BannerLoading from "../components/BannerLoading";
import jt from "../assets/home-page/jt.png"
import animateCss from "../utils";
import Loading from "../components/Loading"
import $ from "jquery"
import case6 from "../assets/home-page/case-6.png";
import case7 from "../assets/home-page/case-7.png";
import case17 from "../assets/home-page/case-17.png";
import case16 from "../assets/home-page/case-16.png";
import case12 from "../assets/home-page/case-12.png";
import projectLogo from "../assets/home-page/projectLogo.png"
import projectMri from "../assets/home-page/project-mri.png"
import projectMeg from "../assets/home-page/project-meg.png"
import projectEeg from "../assets/home-page/project-eeg.png"
import left from "../assets/home-page/left.png"
import center from "../assets/home-page/center.png"
import right from "../assets/home-page/right.png"
import projectArrow from "../assets/home-page/project-arrow.png";
import projectImg1 from "../assets/home-page/project-img1.png"
import projectImg2 from "../assets/home-page/project-img2.png"
import projectImg3 from "../assets/home-page/project-img3.png"
import projectImg4 from "../assets/home-page/project-img4.png"
import projectImg5 from "../assets/home-page/project-img5.png"
import projectImg6 from "../assets/home-page/project-img6.png"
import newsDetaile from "../constants/news-preview/newsDetaile";
import banner1 from "../assets/home-page/banner1.png"
import banner2 from "../assets/home-page/banner2.png"
import banner3 from "../assets/home-page/banner3.png"
import circleImg from "../assets/home-page/circle.png"
import NeuroScholarTM from "../assets/home-page/NeuroScholarTM.png"
import NeuroScholarTM2 from "../assets/home-page/NeuroScholarTM2.png"
import NeuroCollectorTM from "../assets/home-page/NeuroCollectorTM.png"
import NeuroCollectorTM2 from "../assets/home-page/NeuroCollectorTM2.png"
import NeuroSignalTM from "../assets/home-page/NeuroSignalTM.png"
import NeuroSignalTM2 from "../assets/home-page/NeuroSignalTM2.png"
import EpMultiDatabase from "../assets/home-page/EpMultiDatabase.png"
import EpMultiDatabase2 from "../assets/home-page/EpMultiDatabase2.png"
import InsightEpilepsy from "../assets/home-page/InsightEpilepsy.png"
import InsightEpilepsy2 from "../assets/home-page/InsightEpilepsy2.png"
import descImg1 from "../assets/home-page/desc-img-1.png"
import descImg2 from "../assets/home-page/desc-img-2.png"
import case0 from "../assets/home-page/case-0.png"
import case1 from "../assets/home-page/case-1.png"
import case2 from "../assets/home-page/case-2.png"
import case3 from "../assets/home-page/case-3.png"
import case4 from "../assets/home-page/case-4.png"
import case5 from "../assets/home-page/case-5.png"
import case8 from "../assets/home-page/case-8.png"
import case9 from "../assets/home-page/case-9.png"
import case10 from "../assets/home-page/case-10.png"
import case11 from "../assets/home-page/case-11.png"
import case13 from "../assets/home-page/case-13.png"
import case14 from "../assets/home-page/case-14.png"
import case15 from "../assets/home-page/case-15.png"
import case18 from "../assets/home-page/case-18.png"


class HomePage extends React.Component {
    
    ref = React.createRef()
    noRef = React.createRef()
    section3 = React.createRef()

    state = {
        isTop: true,
        current: 0,
        slideIndex: 0,
        distance: 0
    }

    banners = [
        <img src={index1}/>,
        <img src={index2}/>,
        <img src={index3}/>,
    ]


    componentDidMount() {
        window.scrollTo(0,0)
        const swiper = new window.Swiper(".swiper", {
            direction: "horizontal",
            autoplay: {
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
                delay: 2000
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            slidesPerView: 3
        })
        this.isInViewport("section-2", "section2")
        this.setState({ swiper })
        window.addEventListener("scroll", () => {
            this.isInViewport("section-2", "section2")
        })
        // setTimeout(() => {
        //     window.timer = setInterval(() => {
        //         this.next()
        //     }, 5000)
        // }, 5000)

        window.timer = setInterval(() => {
            this.next()
        }, 5000)

        const isVisited = sessionStorage.getItem("isVisited")
        if (!isVisited) {
            sessionStorage.setItem("isVisited", "true")
            this.setState({ isVisited: false })
        } else {
            this.setState({ isVisited: true })
            this.setLoaded(true)
        }
    }

    isInViewport(element, section) {
        if ($("."+ element).length == 0) return false;
        let jqEl = $("."+ element) 
        element = $("."+ element)[0]
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        
        var top = document.documentElement.clientTop;
        if(
            rect.bottom - top <= (window.innerHeight || html.clientHeight) + 200
        ){
            this.setState({ [section]: true })
        };
    }

    componentWillUnmount() {
        clearInterval(window.timer)
    }

    setCurrent(current) {
        this.setState({ current })
    }

    setLoaded(loaded) {
        this.setState({ loaded })
    }

    nextByClick() {
        this.next()
        // clearInterval(window.timer)
        // window.timer = setInterval(() => {
        //     this.next()
        // }, 5000)
    }

    next() {
        if (this.state.current > 1) {
            this.ref.current.goTo(0)
        } else {
            this.ref.current.next()
        }
        Array.from(document.getElementsByClassName("hidden")).forEach(item => item.style.visibility = "hidden")
        this.noRef.current.next()
    }
    
    setDataIndex(el) {
        this.setState({ slideIndex: Number(el.getAttribute("dataindex")) })
    }

    mouseIn(i, e) {
        if (i <= 3) {
            animateCss("#normal"+i, "slideOutRight")
        }
        animateCss("#line" + i, "slideInLeft")
        .then(node => {
            node.style.visibility = "visible"
        })
    }

    mouseOut(i, e) {
        if (i <= 3) {
            document.getElementById("normal"+i).classList = ["normal"]
            animateCss("#normal"+i, "slideInLeft")
        }
        animateCss("#line" + i, "slideOutRight")
        .then(node => {
            node.classList = ["underline"]
            node.style.visibility = "hidden"
        })
    }

    checkoutNo(current) {
        this.setCurrent(current)
        // this.noRef.current.next()
    }

    render() {
        return <div className="hb-home-page">
                { this.state.isVisited ? null : <Loading onLoaded={()=>this.setLoaded(true)}/> }
                <div className="section-1">
                <Carousel dots={false} ref={this.ref} afterChange={(current) => {
                    this.checkoutNo(current)
                }}>
                    <div className="hb-banner-img">
                        <div className="banner1-info">
                            <div className="banner-text">
                                <span id="mask1-txt1" className="hidden" style={{ visibility: "hidden" }}>支持脑科学研究</span>
                                {
                                    this.state.loaded && this.state.current === 0
                                    ?
                                    <BannerLoading loaded={this.state.loaded} el="mask1-txt1" delay={0}/>
                                    :
                                    null
                                }
                            </div>
                            <div className="banner-text">
                                <span id="mask1-txt2" className="hidden" style={{ visibility: "hidden" }}>助力脑疾病诊疗</span>
                                {
                                    this.state.loaded && this.state.current === 0
                                    ?
                                    <BannerLoading loaded={this.state.loaded} el="mask1-txt2" delay={300}/>
                                    :
                                    null
                                }
                            </div>
                            <div className="banner1-theme" >
                                <div className="theme-wrap hidden" id="theme1-wrap" style={{ visibility: "hidden" }}>
                                    <div className="hb-short-line"></div>
                                    <div className="banner-theme-txt">我们的愿景</div>
                                </div>
                                {
                                    this.state.loaded && this.state.current === 0
                                    ?
                                    <BannerLoading loaded={this.state.loaded} background={"#56FDFE"} el="theme1-wrap" delay={500}/>
                                    :
                                    null
                                }
                            </div>
                        </div>
                        <img src={banner1} className="banner-img"/>
                    </div>
                    <div className="hb-banner-img">
                        <div className="banner2-info">
                            <div className="banner-text">
                                    <span id="mask2-txt1" className="hidden" style={{ visibility: "hidden" }}>探索有效的脑疾病影像学标记物</span>
                                    {
                                        this.state.loaded && this.state.current === 1
                                        ?
                                        <BannerLoading loaded={this.state.loaded} el="mask2-txt1" delay={0}/>
                                        :
                                        null
                                    }
                            </div>
                            <div className="banner2-info-line2 banner-text">
                                <span id="mask2-txt2" className="hidden" style={{ visibility: "hidden", height: "2rem", whiteSpace: "nowrap" }}>提供个体化脑影像计算分析一站式解决方案</span>
                                {
                                    this.state.loaded && this.state.current === 1
                                    ?
                                    <BannerLoading loaded={this.state.loaded} el="mask2-txt2" delay={300}/>
                                    :
                                    null
                                }
                            </div>
                            <div className="banner1-theme">
                                <div className="theme-wrap hidden" id="theme2-wrap" style={{ visibility: "hidden" }}>
                                    <div className="hb-short-line"></div>
                                    <div className="banner-theme-txt">我们的产品</div>
                                </div>
                                {
                                    this.state.loaded && this.state.current === 1
                                    ?
                                    <BannerLoading loaded={this.state.loaded} el="theme2-wrap" background={"#56FDFE"} delay={500}/>
                                    :
                                    null
                                }
                            </div>
                        </div>
                        <img src={banner2} />
                    </div>
                    <div className="hb-banner-img">
                        <div className="banner3-info">
                            <div className="banner-text">
                                <div id="mask3-txt1" className="mask3-text1 hidden">优化癫痫外科诊疗流程</div>
                                {
                                    this.state.loaded && this.state.current === 2
                                    ?
                                    <BannerLoading loaded={this.state.loaded} el="mask3-txt1" delay={0}/>
                                    :
                                    null
                                }
                            </div>
                            <div className="banner3-info-line2 banner-text">
                                <span id="mask3-txt2" className="hidden">聚焦于癫痫致痫灶的无创精准定位</span>
                                {
                                    this.state.loaded && this.state.current === 2
                                    ?
                                    <BannerLoading loaded={this.state.loaded} el="mask3-txt2" delay={300}/>
                                    :
                                    null
                                }
                            </div>
                            <div className="banner1-theme">
                                <div className="theme-wrap hidden" id="theme3-wrap" style={{ visibility: "hidden" }}>
                                    <div className="hb-short-line"></div>
                                    <div className="banner-theme-txt">我们的产品</div>
                                </div>
                                
                                {
                                    this.state.loaded && this.state.current === 2
                                    ?
                                    <BannerLoading loaded={this.state.loaded} background={"#56FDFE"} el="theme3-wrap" delay={500}/>
                                    :
                                    null
                                }
                            </div>
                        </div>
                        <img src={banner3} />
                    </div>
                    <div className="hb-banner-img">
                        <img src={banner1}/>
                    </div>
                </Carousel>
                <div className="banner-side-ctrl">
                    <div className="checkout-img" onClick={()=>this.nextByClick()}>
                        <Carousel ref={this.noRef} dots={false} vertical={true} infinite={true} dotPosition="right">
                            {this.banners.map((item, index) => <div key={"img-"+ index}>{item}</div>)}
                        </Carousel>
                    </div>
                    <div className="split-icon">
                        <img src={split} />
                    </div>
                    <div className="checkout-img" onClick={()=>this.nextByClick()}>
                        <img src={index3} />
                    </div>
                </div>
                <div className="news" onClick={()=>this.props.history.push("/latest-news")}>
                    <img src={circleTxt} />
                    <span>最新动态</span>
                </div>
            </div>
            <div className="section-2">
                {
                    this.state.section2 && this.state.loaded
                    ?
                    <div className="section-2-title">
                        <span className="section-2-title-left">慧脑云产品概览</span>
                        <span className="hb-split-line"></span>
                        <span className="section-2-title-right">
                            <div>PRODUCT</div>
                            <div>OVERVIEW</div>
                        </span>
                    </div>
                    :
                    null
                }
                <div className="section-2-main">
                    {
                        this.state.section2 && this.state.loaded
                        ?
                        <div className="animation-space">
                            <img src={circleImg} className="project-circle" />
                            <img src={right} className="project-img left" />
                            <img src={center} className="project-img center" />
                            <img src={left} className="project-img right" />
                            <img src={projectLogo} className="project-logo"/>
                            <img src={projectArrow} className="project-left-arrow"/>
                            <img src={projectArrow} className="project-right-arrow"/>
                            <div className="project-intruduce">
                                <div className="top">
                                    <p>基于脑影像的</p>
                                    <p>脑疾病精准诊疗</p>
                                </div>
                                <div className="bottom">
                                    <p>癫痫致痫灶</p>
                                    <p>无创精准定位</p>
                                </div>
                            </div>
                            <ul className="projects">
                                <li className="mri"><img src={projectMri} /><span>MRI</span></li>
                                <li className="meg"><img src={projectMeg} /><span>MEG</span></li>
                                <li className="eeg"><img src={projectEeg} /><span>EEG</span></li>
                            </ul>
                            <ul className="project-img-list">
                                <li><img src={projectImg1} className="margin-1"/></li>
                                <li><img src={projectImg2} className="margin-2"/></li>
                                <li><img src={projectImg3} className="margin-3"/></li>
                                <li><img src={projectImg4} className="margin-3"/></li>
                                <li><img src={projectImg5} className="margin-2"/></li>
                                <li><img src={projectImg6} className="margin-1"/></li>
                            </ul>
                        </div>
                        :
                        null
                    }
                    {/* <img src={section2} style={{width: "34.2667rem", height: "16.5333rem"}}/> */}
                </div>
                <div className="section-2-footer">
                    <div className="swiper section-2-slider">
                        <div className="swiper-wrapper">
                            <div 
                                className="swiper-slide" 
                                onMouseOver={(e)=>this.setDataIndex(e.target)}
                                onClick={() => this.props.history.push({ pathname: "/project-pipe", state: { activeSlide: 1, goToBar: true } })}
                            >
                                <img dataindex={1} 
                                    src={this.state.slideIndex === 1 ? NeuroScholarTM : NeuroScholarTM2} 
                                />
                            </div>
                            <div 
                                className="swiper-slide"
                                onMouseOver={(e)=>this.setDataIndex(e.target)}
                                onClick={() => this.props.history.push({ pathname: "/project-pipe", state: { activeSlide: 2, goToBar: true } })}
                            >
                                <img dataindex={2} 
                                    src={this.state.slideIndex === 2 ? NeuroCollectorTM : NeuroCollectorTM2} 
                                />
                                {/* <img dataindex={2} src={this.state.slideIndex === 2 ? button : buttonDeep} className="try-button"/> */}
                            </div>
                            <div 
                                className="swiper-slide" 
                                onMouseOver={(e)=>this.setDataIndex(e.target)}
                                onClick={() => this.props.history.push({ pathname: "/project-pipe", state: { activeSlide: 3, goToBar: true } })}
                            >
                                <img dataindex={3} 
                                    src={this.state.slideIndex === 3 ? NeuroSignalTM : NeuroSignalTM2} 
                                />
                            </div>
                            <div 
                                className="swiper-slide" 
                                onMouseOver={(e)=>this.setDataIndex(e.target)}
                                onClick={() => this.props.history.push({ pathname: "/project-pipe", state: { activeSlide: 4, goToBar: true } })}
                            >
                                <img dataindex={4} 
                                    src={this.state.slideIndex === 4  ? InsightEpilepsy : InsightEpilepsy2} 
                                />
                            </div>
                            <div 
                                className="swiper-slide" 
                                onMouseOver={(e)=>this.setDataIndex(e.target)}
                                onClick={() => this.props.history.push({ pathname: "/project-pipe", state: { activeSlide: 5, goToBar: true } })}
                            >
                                <img dataindex={5} 
                                    src={this.state.slideIndex === 5 ? EpMultiDatabase : EpMultiDatabase2} 
                                /> 
                            </div>
                            {/* <div className="swiper-slide" >
                                <img dataindex={6} src={this.state.slideIndex === 6 ? dxdmt : dxdmtDeep} onMouseOver={(e)=>this.setDataIndex(e.target)}/>
                            </div> */}
                        </div>
                        <div className="swiper-button-prev"></div>
                        <div className="swiper-button-next"></div>
                    </div>
                </div>
            </div>
            <div className="section-3">
                <div className="section-3-container">
                    <div>
                        <div className="section-3-title">
                            <div className="Chinese-title">用户案例</div>
                            <span className="hb-split-line"></span>
                            <div className="English-title">
                                <div>&nbsp;</div>
                                <div>CASES</div>
                            </div>
                        </div>
                    </div>
                    <div className="case-text-1">
                        <img src={descImg1} />
                        <div>
                            <p>慧脑云聚焦于多模态脑影像与神经电生理前沿算法研发，</p>
                            <p>助力医生与临床研究工作者探索有效的脑重大疾病生物学标记物。</p>
                        </div>
                    </div>
                    <img src={case0} className="case-0"/>
                    <div className="case-text-1">
                        <img src={descImg2} />
                        <div>
                            <p>NeuroScholar 产品已经销售给几十家知名三甲医院和脑科学研究机构。</p>
                            <p>为多种脑重大疾病的临床研究成果转化与个体化精准诊疗提供技术支撑。</p>
                        </div>
                    </div>
                    <div className="case-items">
                        <ul className="case-list-1">
                            <li className="row-1">
                                <div className="row-title">
                                    <p>脑疾病</p>
                                    <p>临床机构</p>
                                </div>
                                <li className="split-line"></li>
                                <ul className="row-1-img">
                                    <li><img src={case1} /></li>
                                    <li><img src={case17} /></li>
                                    <li><img src={case5} /></li>
                                    <li style={{ display: "flex", alignItems: "center" }}><img src={case3} style={{ width: "3rem", height: "3rem" }}/></li>
                                    <li style={{ display: "flex", alignItems: "center" }}><img src={case9} style={{ width: "3.0667rem", height: "3.2rem" }}/></li>
                                </ul>
                            </li>
                            <li className="row-1">
                                <ul className="row-1-img">
                                    <li className="first"><img src={case2}/></li>
                                    <li><img src={case8} /></li>
                                    <li><img src={case6} /></li>
                                    <li className="special-width"><img src={case7}/></li>
                                    <li style={{ display: "flex", alignItems: "center" }}><img src={case4} style={{ width: "3rem", height: "3rem" }}/></li>
                                    <li style={{ display: "flex", alignItems: "center" }}><img src={case15} style={{ width: "3.3rem", height: "3.3rem" }}/></li>
                                </ul>
                            </li>
                        </ul>
                        <div className="list-split-line"></div>
                        <ul className="case-list-1">
                        <li className="row-1">
                                <div className="row-title">
                                    <p>脑科学</p>
                                    <p>研究机构</p>
                                </div>
                                <li className="split-line"></li>
                                <ul className="row-1-img">
                                    <li><img src={case13} /></li>
                                    <li><img src={case10} /></li>
                                    <li><img src={case11} /></li>
                                </ul>
                            </li>
                            <li className="row-1">
                                <ul className="row-1-img">
                                    <li className="first special-img"><img src={case16} /></li>
                                    <li><img src={case18} /></li>
                                    <li><img src={case12} /></li>
                                    <li><img src={case14} /></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    
                </div>
                <div className="more-users" onClick={()=>window.scrollTo(0, 0)}>
                    <div className="more-line"></div>
                    <div className="text"><Link to="/user-case">更多案例</Link></div>
                </div>
            </div>
            <div className="section-4">
                <div className="section-4-left">
                    <div className="content">
                        <div className="content-title">
                            <div className="Chinese-title">慧脑云</div>
                            <span className="hb-split-line"></span>
                            <div className="English-title">
                                {/* <div>&nbsp;</div> */}
                                <div>COMPANY</div>
                            </div>
                        </div>
                        <div className="profile">
                            <div>
                                公司具备强大的脑科学产品研发与落地能力，致力于个体化的脑重大疾病精准诊疗、个体化的脑健康监测、脑科学的前沿基础研究与临床应用等脑医学与脑健康领域的前沿探索。
                            </div>
                            <div className="learn-more">
                                <div className="hb-short-line"></div>
                                <Link to="/about-us" onClick={()=>window.scrollTo(0, 0)}>了解更多</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-4-right">
                    <div className="content">
                        <div className="content-title">
                            <div className="Chinese-title">我们的团队</div>
                            <span className="hb-split-line"></span>
                            <div className="English-title">
                                <div>TEAM</div>
                            </div>
                        </div>
                        <div className="profile">
                            <div>
                                公司汇聚了脑科学与人工智能领域的学者与技术专家，核心团队来自北京大学、中科院、加拿大麦吉尔大学等脑科学与人工智能领域国内外著名学府，是多项国家重大课题的课题骨干。
                            </div>
                            <div className="learn-more">
                                <div className="hb-short-line"></div>
                                <Link to={{ pathname: "/about-us", state: { target: "about-part-3" }}} onClick={()=>window.scrollTo(0, 0)}>了解更多</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-5">
                <div className="section-5-left">
                    <div className="content-title">
                        <div className="Chinese-title">新闻动态</div>
                        <span className="hb-split-line"></span>
                        <div className="English-title">
                            <div>&nbsp;</div>
                            <div>NEWS</div>
                        </div>
                    </div>
                    <div className="learn-more">
                        <div className="hb-short-line"></div>
                        <Link to="/latest-news" onClick={()=>window.scrollTo(0, 0)}>查看全部</Link>
                    </div>
                </div>
                <div className="section-5-right">
                    {
                        newsDetaile.map((news, index) => {
                            if (index <= 2) {
                                return <div className="news">
                                    <div 
                                        className="news-container" 
                                        onMouseEnter={(e)=>this.mouseIn(index + 1)} 
                                        onMouseLeave={(e)=>this.mouseOut(index + 1)}
                                        onClick={()=>this.props.history.push({ pathname: "/news-detail", state: { newsId: index } })}
                                    >
                                        <div className="time">{news.header[0].split("月")[0] + "月"}</div>
                                        <div className="action">
                                            <div>{news.title}</div>
                                            <img src={jt} />
                                        </div>
                                    </div>
                                    <div className="underline normal" id={"normal" + (index + 1)}></div>
                                    <div className="underline" id={"line" + (index + 1)} style={{visibility: "hidden"}}></div>
                                </div>
                            } else {
                                return null
                            }
                        })
                    }
                    {/* <div className="news">
                        <div className="news-container" onMouseEnter={(e)=>this.mouseIn(1)} onMouseLeave={(e)=>this.mouseOut(1)}>
                            <div className="time">2021年10月</div>
                            <div className="action">
                                <div >慧脑云荣获北京市科委“AI+健康协同创新培育”项目支持</div>
                                <img src={jt} />
                            </div>
                        </div>
                        <div className="underline normal" id="normal1"></div>
                        <div className="underline" id="line1" style={{visibility: "hidden"}}></div>
                    </div>
                    <div className="news">
                        <div className="news-container" onMouseEnter={(e)=>this.mouseIn(2)} onMouseLeave={()=>this.mouseOut(2)}>
                            <div className="time">2021年10月</div>
                            <div className="action">
                                <div >慧脑云专家参与研发基于皮层的磁共振脑影像数据处理与分析软件DPABISurf</div>
                                <img src={jt} />
                            </div>
                        </div>
                        <div className="underline normal" id="normal2"></div>
                        <div className="underline" id="line2" style={{visibility: "hidden"}}></div>
                    </div>
                    <div className="news">
                        <div className="news-container" onMouseEnter={(e)=>this.mouseIn(3)} onMouseLeave={()=>this.mouseOut(3)}>
                            <div className="time">2021年10月</div>
                            <div className="action">
                                <div >基金委重大项目“癫痫异常脑功能活动位点和连接的多模态影像学研究”正式启动</div>
                                <img src={jt} />
                            </div>
                        </div>
                        <div className="underline normal" id="normal3"></div>
                        <div className="underline" id="line3" style={{visibility: "hidden"}}></div>
                    </div> */}
                </div>
            </div>
        </div>
    }
    
}
export default HomePage;
   
   
   